import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

import SwitchRouter from 'components/application/switch-router'
import { ThemeProvider } from '@mui/material'
import TMBlueTheme from 'theme'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { LicenseInfo } from '@mui/x-license-pro'
import { Loading } from 'components/atoms/Loading'

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_API_KEY)

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ThemeProvider theme={TMBlueTheme}>
            <SwitchRouter />
          </ThemeProvider>
        </LocalizationProvider>
      </Suspense>
    </BrowserRouter>
  )
}
